module.exports = __webpack_public_path__ + "static/zdjęcia1-5e429153bc5d94225f29c022436f66b1.svg";